import {Controller, useFormContext} from 'react-hook-form';
import * as React from 'react';
import {useState} from 'react';
import {useTranslation} from "react-i18next";
import {DatePicker, DatePickerProps, DateValidationError} from "@mui/x-date-pickers";
import {DateTime} from "luxon";
import {FormHelperText} from "@mui/material";

const INVALID_DATE = 'invalid';

export function MuiRhfDatePicker(props: {
  name: string,
  required?: boolean,
} & Partial<Omit<DatePickerProps<any>, 'onChange' | 'value'>>) {
  const {name, minDate, maxDate, ...rest} = props;
  const {control} = useFormContext<any>();
  const {t} = useTranslation();
  const [customErrors, setCustomerErrors] = useState<string>();

  function parseDate(dateStr?: string) {
    if (!dateStr) {
      return undefined;
    }
    const dateTime = DateTime.fromISO(dateStr);
    // console.info("Parsed date", dateTime, dateTime.toISODate())
    if (dateTime?.isValid) {
      return dateTime;
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={renderProps => {
        const value = renderProps.field.value || null;
        return <>
          <DatePicker
            format={t('common.date')}
            onChange={(newDate: DateTime | null) => {
              // A cleared field must become null - storing anything else breaks validation and saving (SSO-298).
              // Incomplete keyboard input is kept as an invalid value so that validation blocks saving.
              renderProps.field.onChange(newDate ? (newDate.isValid ? newDate.toISODate() : INVALID_DATE) : null);
            }}
            onAccept={(newDate: DateTime | null) => {
              renderProps.field.onChange(newDate?.toISODate() ?? null);
            }}
            onError={(error: DateValidationError) => setCustomerErrors(error ? t('FormErrors.' + error) + '' : undefined)}
            value={value ? DateTime.fromISO(value) : undefined}
            timezone={"system"}
            minDate={parseDate(minDate)}
            maxDate={parseDate(maxDate)}
            views={['year', 'month', 'day']}
            slotProps={{field: {clearable: true}}}
            // renderInput={(params) => <TextField {...params} variant={'outlined'} InputLabelProps={{shrink: true}}/>}
            {...rest}
          />
          {!props.disabled &&
            <FormHelperText>{customErrors || renderProps.fieldState.error?.message}</FormHelperText>
          }
        </>;
      }
      }
    />
  );
}
